import React, { useEffect, useState } from "react";
import FaqForm from "./FaqForm";
import AdminPageLayout from "../AdminPageLayout";
import "../AdminPageLayout.css";
import "./faq.css";
import { fetchAllFaqs, deleteFaq as deleteFaqService } from "./adminFaqService";

const AdminFaqPage = () => {
  const [faqs, setFaqs] = useState([]);
  const [editing, setEditing] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => { loadFaqs(); }, []);

  const loadFaqs = async () => {
    setLoading(true);
    const res = await fetchAllFaqs();
    if (res.status === 200) setFaqs(res.data);
    else alert(res.message || "Failed to load FAQs");
    setLoading(false);
  };

  const deleteFaq = async (id) => {
    if (!window.confirm("Delete this FAQ?")) return;
    const res = await deleteFaqService(id);
    if (res.status === 200 || res.status === 204) loadFaqs();
    else alert(res.message || "Delete failed");
  };

  const onFormSaved = () => { setShowForm(false); loadFaqs(); };

  return (
    <AdminPageLayout
      title="FAQ Management"
      subtitle="Manage frequently asked questions displayed in the app."
      instruction="FAQs are shown on the Help / Support screen. Optionally attach a YouTube video link to provide a visual explanation. Keep answers concise and clear for best user experience."
      actions={
        <button className="adm-btn adm-btn-primary" onClick={() => { setEditing(null); setShowForm(true); }}>
          + New FAQ
        </button>
      }
    >
      {showForm && (
        <div className="adm-form-card">
          <FaqForm faq={editing} onSaved={onFormSaved} onCancel={() => setShowForm(false)} />
        </div>
      )}

      {loading ? (
        <p className="adm-loading">Loading FAQs…</p>
      ) : (
        <div className="adm-table-wrap">
          <table className="adm-table">
            <thead>
              <tr>
                <th style={{ minWidth: 220 }}>Question</th>
                <th style={{ minWidth: 280 }}>Answer</th>
                <th>Video</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {faqs.length === 0 ? (
                <tr><td colSpan="4" className="adm-empty">No FAQs found</td></tr>
              ) : (
                faqs.map((faq) => (
                  <tr key={faq.id}>
                    <td style={{ fontWeight: 500 }}>{faq.question}</td>
                    <td style={{ color: "#475569" }}>{faq.answer}</td>
                    <td>
                      {faq.youtubeVideoLink ? (
                        <a href={faq.youtubeVideoLink} target="_blank" rel="noreferrer" className="adm-badge adm-badge-blue" style={{ textDecoration: "none" }}>
                          ▶ Watch
                        </a>
                      ) : (
                        <span className="adm-badge adm-badge-gray">—</span>
                      )}
                    </td>
                    <td>
                      <div style={{ display: "flex", gap: 6 }}>
                        <button className="adm-btn adm-btn-ghost adm-btn-sm" onClick={() => { setEditing(faq); setShowForm(true); }}>Edit</button>
                        <button className="adm-btn adm-btn-danger adm-btn-sm" onClick={() => deleteFaq(faq.id)}>Delete</button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </AdminPageLayout>
  );
};

export default AdminFaqPage;
